import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./AccountDeletion.css";
import { get, post } from "../../../api/api";

const ConfirmAccountDeletion = () => {
  const [loading, setLoading] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [confirmationInput, setConfirmationInput] = useState("");
  const [error, setError] = useState("");

  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setTokenValid(false);
        setLoading(false);
        return;
      }

      try {
        const encoded = encodeURIComponent(token);
        const data = await get(
          `/users/delete/verify-delete-token?token=${encoded}`
        );
        setTokenValid(data.valid === true);
      } catch {
        setTokenValid(false);
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, [token]);

  const confirmAccountDeletion = async () => {
    if (confirmationInput.trim().toUpperCase() !== "DELETE") {
      setError("You must type DELETE to confirm.");
      return;
    }

    try {
      await post("/users/delete/confirm-delete", { token });
      setDeleteSuccess(true);
    } catch {
      setDeleteSuccess(false);
    }
  };

  if (loading) {
    return (
      <div className="deletion-container">
        <p>Verifying deletion link...</p>
      </div>
    );
  }

  if (deleteSuccess) {
    return (
      <div className="deletion-success-container">
        <h2>Account Deleted</h2>
        <p>Your GoalFlex account has been successfully deleted.</p>
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className="deletion-invalid-container">
        <h2>Deletion Link Expired or Invalid</h2>
        <p>
          This link is no longer valid. It might be expired or already used.
        </p>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="deletion-container">
        <h2>Confirm Account Deletion</h2>
        <p>
          This action is <strong>permanent</strong>. To continue, type{" "}
          <code>DELETE</code> below.
        </p>
        <input
          type="text"
          placeholder="Type DELETE to confirm"
          value={confirmationInput}
          onChange={(e) => {
            setConfirmationInput(e.target.value);
            setError("");
          }}
          className="deletion-input"
        />
        {error && <p style={{ color: "red", marginBottom: 12 }}>{error}</p>}
        <button onClick={confirmAccountDeletion} className="deletion-button">
          Confirm Deletion
        </button>
      </div>
    </div>
  );
};

export default ConfirmAccountDeletion;
